import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RenderContextComponent } from '../../../../../../../models/base/render-context-component';
import { Menu } from '../../../../../../../models/menu/menu';

@Component({
  selector: 'app-menu-header',
  template: '',
  standalone: false
})
export abstract class MenuHeaderComponent extends RenderContextComponent implements OnChanges {
  @Input() menu: Menu;
  @Input() reset: boolean;

  setupBindings() {}

  setupViews() {}

  /* We need this here, so that in the inflator we can pass down any changes  */
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnChanges(changes: SimpleChanges) {}
}
